import { useEffect, useState } from "react";
import { DeviceMobile as Smartphone, X } from "@phosphor-icons/react";

const KEY = "pr.a2hs.card.dismissed";

const COLOR = { ink: "var(--pr-ink)", ink2: "var(--pr-ink2)", muted: "var(--pr-muted)", gold: "var(--pr-gold)", line: "var(--pr-line)" };

export const InstallAppCard = () => {
  const [installEvent, setInstallEvent] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
  });

  useEffect(() => {
    setInstalled(window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true);
    const prompt = (e) => { e.preventDefault(); setInstallEvent(e); };
    const done = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", prompt);
    window.addEventListener("appinstalled", done);
    return () => {
      window.removeEventListener("beforeinstallprompt", prompt);
      window.removeEventListener("appinstalled", done);
    };
  }, []);

  if (installed || dismissed) return null;

  const isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;

  const dismiss = () => {
    try { localStorage.setItem(KEY, "1"); } catch { /* storage unavailable */ }
    setDismissed(true);
  };

  const install = async () => {
    if (!installEvent) return;
    installEvent.prompt();
    const { outcome } = await installEvent.userChoice;
    if (outcome === "accepted") setInstalled(true);
    setInstallEvent(null);
  };

  return (
    <div
      className="relative rounded-2xl p-5 lg:p-6 pr-card lg:hidden"
      data-testid="install-app-card"
    >
      <button
        onClick={dismiss}
        className="absolute top-2.5 right-2.5 p-1 rounded-full"
        style={{ color: COLOR.muted }}
        aria-label="Dismiss"
        data-testid="install-app-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-3 pr-5">
        <span className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "rgba(245,203,92,0.25)" }}>
          <Smartphone className="w-4 h-4" style={{ color: COLOR.ink }} />
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold mb-0.5" style={{ color: COLOR.ink }}>
            Keep Payday Relay one tap away
          </p>
          {installEvent ? (
            <>
              <p className="text-[11px] leading-relaxed mb-2.5" style={{ color: COLOR.ink2 }}>
                Add it to your home screen and it opens like a real app. No download, no app store.
              </p>
              <button
                onClick={install}
                className="text-xs font-bold px-4 py-2 rounded-full pr-btn-primary"
                data-testid="install-app-btn"
              >
                Add to Home Screen
              </button>
            </>
          ) : isIOS ? (
            <p className="text-[11px] leading-relaxed" style={{ color: COLOR.ink2 }}>
              Two taps: hit <b>Share</b> (⬆️) at the bottom of Safari, then <b>Add to Home Screen</b>.
            </p>
          ) : (
            <p className="text-[11px] leading-relaxed" style={{ color: COLOR.ink2 }}>
              Open your browser menu and choose <b>Add to Home Screen</b> or <b>Install app</b>.
            </p>
          )}
          <p className="text-[10px] mt-2.5 leading-relaxed" style={{ color: COLOR.muted }} data-testid="install-app-findable-note">
            Need it later? It always lives under <b>More → Add to Home Screen</b>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InstallAppCard;
